import { useMemo } from 'react';
import { useGetCommentDocumentsByIdQuery } from '../../../../api/endpoints/technicalSupportRequest';
import { getDocId } from '../utils/documentUtils';

const useCommentDocuments = (commentId) => {
    const { data: documentsRaw, isLoading, isFetching } = useGetCommentDocumentsByIdQuery(commentId, { skip: !commentId });

    const documents = useMemo(() => (Array.isArray(documentsRaw) ? documentsRaw : documentsRaw?.data ?? documentsRaw?.items ?? documentsRaw?.Data ?? []), [documentsRaw]);
    const documentIds = useMemo(() => documents.map(getDocId).filter(Boolean), [documents]);

    return { documents, documentIds, isLoading: isLoading || isFetching };
};

export default useCommentDocuments;
